import { BASE_URL, JOBS_BY_DEPARTMENTS, PUBLIC } from "../../common/URLs"

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${JOBS_BY_DEPARTMENTS}`

export const fetchPopularJobCategoriesList = async (uuid, page = 1, perPage = 15) => {
  // Add pagination parameters to the URL
  const url = `${API_BASE_URL}/${uuid}?page=${page}&per_page=${perPage}`

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.log("error", error)
    throw error // Re-throw to handle in the thunk
  }
}
